var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "热搜词配置",
        width: "520px",
        top: "120px",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "搜索词次数<", prop: "minSearchCount" } },
            [
              _c(
                "div",
                { staticClass: "inline-form-item" },
                [
                  _c("el-input", {
                    staticClass: "config-input",
                    attrs: { size: "small", placeholder: "请输入次数" },
                    model: {
                      value: _vm.form.minSearchCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "minSearchCount", $$v)
                      },
                      expression: "form.minSearchCount",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("不计入统计")]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "小程序热搜词数量", prop: "hotTermCount" } },
            [
              _c("el-input", {
                staticClass: "config-input",
                attrs: { size: "small", placeholder: "请输入数量" },
                model: {
                  value: _vm.form.hotTermCount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "hotTermCount", $$v)
                  },
                  expression: "form.hotTermCount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }